import Button from '../../Common/Button';
import pdf from '../../../../assets/img/svg/buttons/pdf.svg';
import { t } from 'i18next';
import { PDF } from '../../../../constant/constants';

interface PDFProps {
  className?: string;
  filled?: string;
  mobile?: boolean;
}

const ExportToPDF: React.FC<PDFProps> = ({ className, filled, mobile }) => {
  const exportPDF = () => {};

  return (
    <>
      <Button icon={pdf} onClick={exportPDF} variant={filled || 'filled'} className={className || 'pdf_button'} />{' '}
      {mobile ? (
        <p>
          {t(`statisticPage.header.export.exportAs`)}
          <span>{PDF}</span>
        </p>
      ) : null}
    </>
  );
};

export default ExportToPDF;
